(() => {
  function init(root) {
    if (root.dataset.mapReady) return;
    root.dataset.mapReady = 'true';
    const cards = Array.from(root.querySelectorAll('[data-card]'));
    const shortcuts = Array.from(root.querySelectorAll('[data-shortcut]'));
    const input = root.querySelector('[data-canton-search]');
    const normalize = value => value.toLocaleLowerCase('de-CH').normalize('NFD').replace(/[\u0300-\u036f]/g, '').replace(/[-.]/g, ' ');
    input?.addEventListener('input', () => {
      const query = normalize(input.value.trim());
      let count = 0;
      for (const card of cards) {
        const match = normalize(card.dataset.search).includes(query);
        card.hidden = !match;
        if (match) count++;
        const shortcut = shortcuts.find(item => item.dataset.shortcut === card.dataset.card);
        if (shortcut) shortcut.hidden = !match;
      }
      root.querySelector('[data-search-status]').textContent = count === 26 ? 'Alle 26 Kantone entdecken' : count ? `${count} ${count === 1 ? 'Kanton' : 'Kantone'} gefunden` : 'Kein Kanton gefunden. Versuche einen anderen Namen.';
    });
    function preview(link) {
      const card = cards.find(item => item.dataset.card === link.dataset.canton);
      if (!card) return;
      root.querySelector('.cc-preview-default').hidden = true;
      root.querySelector('.cc-preview-selection').hidden = false;
      root.querySelector('[data-preview-name]').textContent = card.querySelector('h2').textContent;
      root.querySelector('[data-preview-text]').textContent = card.querySelector('.cc-overview-copy>p').textContent;
      root.querySelector('[data-preview-link]').href = card.href;
      const image = card.querySelector('[data-preview-image], .cc-overview-img img');
      const coat = card.querySelector('[data-preview-coat], .cc-name img');
      const target = root.querySelector('.cc-preview-image');
      target.src = image.dataset.previewImage || image.src;
      target.alt = image.dataset.previewAlt || image.alt;
      target.style.objectFit = card.querySelector('.cc-overview-img--map') ? 'contain' : 'cover';
      root.querySelector('.cc-preview-coat').src = coat.dataset.previewCoat || coat.src;
      root.querySelector('.cc-preview-coat').alt = coat.dataset.previewAlt || coat.alt;
    }
    for (const link of root.querySelectorAll('.cc-map-canton')) {
      link.addEventListener('pointerenter', event => { if (event.pointerType !== 'touch') preview(link); });
      link.addEventListener('focus', () => preview(link));
    }
  }
  document.querySelectorAll('[data-canton-overview]').forEach(init);
  document.addEventListener('shopify:section:load', event => event.target.querySelectorAll('[data-canton-overview]').forEach(init));
})();
